export default __webpack_public_path__ + "static/6-cbe1704d0828a15eef5dce6be7a70899.png";